<template>
    <el-dialog
        :title="classType === 1 ? '选择面授班级' : '选择直播班级'"
        :visible.sync="dialogVisible"
        top="22vh"
        :modal="false"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
    >
        <el-row>
            <el-col :span="12">
                <el-input size="small" v-model="searchName"></el-input>
            </el-col>
            <el-col :span="4">
                <el-button type="primary" size="small" @click="search"
                    >搜索</el-button
                >
            </el-col>
        </el-row>

        <el-table
            :data="tableData"
            height="300"
            style="width: 100%"
            :header-cell-style="{ backgroundColor: '#d7d7d7' }"
            @selection-change="handleSelectionChange"
        >
            <el-table-column
                type="selection"
                width="60"
                align="center"
                :reserve-selection="true"
            >
            </el-table-column>
            <el-table-column prop="batch" label="批次号/班级编码">
            </el-table-column>
            <el-table-column
                prop="className"
                label="班级名称"
            ></el-table-column>
        </el-table>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="comfirm">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { getBatchList } from "@/api/FaceToTeach/classTimeapi.js";
export default {
    props: ["classType", "courseId"],
    data() {
        return {
            // 显示
            dialogVisible: false,
            // 搜索
            searchName: "",
            tableData: this.classList,
            // 选择后
            selectedList: [],
            // 班级列表
            classList: [],
        };
    },
    methods: {
        // 搜索
        search() {
            if (this.searchName.trim() === "")
                return (this.tableData = [...this.classList]);
            this.tableData = [
                this.classList.find((item) => item.batch === this.searchName),
            ];
        },
        // table选择
        handleSelectionChange(arr) {
            this.selectedList = arr;
        },
        // 确认
        comfirm() {
            this.$emit("choseClasses", this.selectedList);
            this.dialogVisible = false;
        },
        // 班级列表
        async getBatchList(newValue) {
            const res = await getBatchList({
                uid: this.getUId,
                courseId: newValue,
            });
            this.classList = res.data.data;
            this.tableData = this.classList;
        },
    },
    created() {
        // this.getBatchList();
    },
    computed: {
        getUId() {
            return localStorage.getItem("uid") || "36";
        },
    },
    watch: {
        courseId: {
            immediate: true,
            handler: function (newValue) {
                if (newValue) {
                    this.getBatchList(newValue);
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
    background-color: #d7d7d7;
}
/deep/.el-dialog__footer {
    text-align: center;
}
/deep/.el-table__header {
    .gutter {
        background-color: #d7d7d7;
    }
}
</style>